import { Pipe } from '@angular/core';
import { isFunction } from '../helpers/helpers';
var IsFunctionPipe = (function () {
    function IsFunctionPipe() {
    }
    IsFunctionPipe.prototype.transform = function (input) {
        return isFunction(input);
    };
    return IsFunctionPipe;
}());
export { IsFunctionPipe };
IsFunctionPipe.decorators = [
    { type: Pipe, args: [{ name: 'isFunction' },] },
];
/** @nocollapse */
IsFunctionPipe.ctorParameters = function () { return []; };
//# sourceMappingURL=is-function.js.map


//////////////////
// WEBPACK FOOTER
// ./~/ngx-pipes/esm/pipes/boolean/is-function.js
// module id = 221
// module chunks = 4